import React from 'react';
import { Table, Divider, Spin} from "antd";
import {summaryColumnData, assetColumnData} from'./columns';
import {getGridTableHeight, getAssetTypeTitle, amountFormatter, floatFormatter} from '../Common/util';
import {Chart01, Chart02, Chart03} from './Chart';

/** -------------------------------------------------------------------------- **/
function Summary({assetType, measureList, assetList, sumData, assetList_u, spinflag}) {

    return (
      <Spin size={"large"}  tip={"Loading..."} spinning={spinflag}>
            <div id="divTabs1" className="section" style={{height:getGridTableHeight(210), overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 이행 영역별 보안수준'}
                        <span style={{color:'blue',paddingLeft:'20px'}}>※ 이행진단의 결과가 등록되지 않은 자산은 초기진단 결과로 분석됩니다.</span>
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table 
                        columns={summaryColumnData}
                        dataSource={measureList}
                        scroll={{y: 240}}
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={2}>{'보안수준(%)=평가점수/전체점수'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2}>{amountFormatter(sumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={3}>{amountFormatter(sumData.check)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.Y)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.N)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.P)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={7}>{amountFormatter(sumData.NA)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{amountFormatter(sumData.total_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={9}>{amountFormatter(sumData.eval_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={10}>{floatFormatter(sumData.level,1)}%</Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ ' + getAssetTypeTitle(assetType) + ' 보안수준'}
                </div>
                <div style={{padding: '5px 10px', height: '200px'}}>
                    <Chart01 dataList={measureList} sumData={sumData} />
                </div>
                <div style={{padding: '5px 10px', height: '400px'}}>
                    <Chart02 dataList={measureList} sumData={sumData} />
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ 장비별 보안수준'}
                        <span style={{color:'blue',paddingLeft:'20px'}}>※ 이행진단의 결과로 등록된 자산은 파란색상으로 표시됩니다..</span>
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table 
                        columns={assetColumnData}
                        dataSource={assetList}
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        summary={(assetList) => {
                          const s_total_score = assetList.reduce( (acc, curr) => acc + curr.total_score,0 );
                          const s_eval_score = assetList.reduce( (acc, curr) => acc + curr.eval_score,0 );
                          const s_level = (s_eval_score /  s_total_score) * 100;
                          return (
                            <>
                              <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={2}>{'보안수준(%)=평가점수/전체점수'}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.total,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.total,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.Y,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={5}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.N,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={6}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.P,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={7}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.NA,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={8}>{amountFormatter(s_total_score)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={9}>{amountFormatter(s_eval_score)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={10}>{floatFormatter(s_level,1)}%</Table.Summary.Cell>
                              </Table.Summary.Row>
                            </>
                          );
                      }}
                      >
                  </Table>
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ ' + getAssetTypeTitle(assetType) + ' 대상별 보안수준'}
                </div>
                <div style={{padding: '5px 10px', height: '200px'}}>
                    <Chart03 dataList={assetList} sumData={sumData} />
                </div>
            </div>
        </Spin>
    );
}
export default Summary;